import { css } from '@emotion/core';
import { IToken } from '../../shared/contexts/styleContext';

export const errorHelperTextStyle = (token?: IToken) => css`
    padding: 0;
    margin: 0;
    color: ${token?.colors?.staticColors?.red ?? 'red'};
    font-size: ${token?.fontSizes?.small ?? '0.8rem'};
`;
